import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { StoreModule } from '@ngrx/store';
import { IconModule } from '@gosuite/icons';
import { InputModule } from '@gosuite/input';

import { AgenciesService } from './agencies.service';
import { AgenciesSelectorComponent } from './agencies-selector.component';


@NgModule({
	declarations: [ AgenciesSelectorComponent ],
	exports: [ AgenciesSelectorComponent ],
	imports: [
		CommonModule,
		FormsModule,
		HttpClientModule,
		StoreModule,
		IconModule,
		InputModule,
	]
})
export class AgenciesModule {
	static forRoot(): ModuleWithProviders {
		return {
			ngModule: AgenciesModule,
			providers: [ AgenciesService ],
		};
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/services/agencies/agencies.module.ts